import { render, staticRenderFns } from "./invoices-client.vue?vue&type=template&id=ea8f8c10&scoped=true"
import script from "./invoices-client.vue?vue&type=script&lang=js"
export * from "./invoices-client.vue?vue&type=script&lang=js"
import style0 from "./invoices-client.vue?vue&type=style&index=0&id=ea8f8c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8f8c10",
  null
  
)

export default component.exports